import { styled } from '@mui/system';
import { Grid, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PreviewIcon from '@mui/icons-material/Preview';

export const ReportBugGridContainer = styled(Grid)(() => ({
  marginLeft: '-9px',
  zIndex: '9999'
}));

export const PickedImageWrapper = styled('div')(()=>({
  display: 'flex',
  flexDirection: 'row',
  marginBlock: '10px'
}));

export const ReportBugButtonsWrapper = styled(Grid)(() => ({
  display: 'flex',
  marginLeft: '15px',
  justifyContent: 'space-between',
  width: '100%'
}));

export const TrashIcon = styled(DeleteIcon)(()=>({
  marginLeft: 'auto',
  cursor: 'pointer',
  transition: 'all 0.4s ease-out',
  '&:hover': {
    color: '#FF596B'
  }
})); 

export const  Preview = styled(PreviewIcon)(()=>({
  cursor: 'pointer',
  marginLeft: '3px',
  transition: 'all 0.4s ease-out',
  '&:hover': {
    color: '#FF596B'
  }
})); 

export const UploadButton = styled('span')(()=>({
  display: 'flex',
  width: '130px',
  backgroundColor: '#E6E6E6',
  justifyContent: 'space-between',
  paddingBlock: '5px',
  paddingInline: '15px',
  borderRadius: '8px',
  transition: 'all 0.4s ease-out',
  '&:hover': {
    color: 'white',
    backgroundColor: '#FF596B',
    cursor: 'pointer',
    borderColor: 'white'
  }
}));

export const ErrorField = styled(Grid)(()=>({
  border: '1px solid red', 
  backgroundColor: 'rgba(255,0,0,0.1)', 
  marginLeft: '15px', 
  width: '100%', 
  marginBottom: '10px', 
  marginTop:'-5px', 
  paddingBlock: '10px', 
  paddingInline: '15px', 
  borderRadius:'10px', 
  display:'flex', 
  justifyContent: 'center'
}));

export const FileTitle = styled(Typography)(()=>({
  display: 'flex', 
  alignItems: 'center', 
  marginLeft: '5px'
}));